import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import type { MerchandiserView } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import { getHeightLandscape } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/merchandiser/helpers/MerchandiserLayoutLandscape';
import {
  getHeightPortrait,
  layoutMerchandiserWithHeight,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/merchandiser/helpers/MerchandiserLayoutPortrait';
import { getWindowProps } from '@Utils/window';

export const layoutMerchandiser = (params: {
  section: MerchandiserView;
  layoutTable: GridCard<PlaneTypes>[][];
}): GridCard<PlaneTypes.Layout_Merchandiser> => {
  const height =
    getLayoutMode() === 'landscape'
      ? getHeightLandscape()
      : getHeightPortrait();

  return layoutMerchandiserWithHeight({
    ...params,
    height,
  });
};
export const getLayoutMode = (): 'landscape' | 'portrait' => {
  const { layoutMode, width } = getWindowProps();

  if (layoutMode === 'landscape') {
    return 'landscape';
  }

  return width >= 1440 ? 'landscape' : 'portrait';
};
